/**
 * API Utility
 * 
 * Centralized API configuration for all fetch calls.
 * In development, uses Vite proxy. In production, uses the full API URL.
 */

export const API_BASE = import.meta.env.VITE_API_URL || '';

/**
 * Make an authenticated API request
 * @param {string} endpoint - API endpoint (e.g., '/api/profiles/me')
 * @param {object} options - Fetch options (method, headers, body, etc.)
 * @returns {Promise<Response>}
 */
export const apiFetch = async (endpoint, options = {}) => {
    const url = `${API_BASE}${endpoint}`;
    return fetch(url, options);
};

export default { API_BASE, apiFetch };
